"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JobStatus = exports.POLL_JOB_TYPES = exports.JobTypes = void 0;
exports.isPollJobType = isPollJobType;
var JobTypes;
(function (JobTypes) {
    JobTypes["TRANSLATION__GENERATE_TRANSLATION"] = "translation:generate_translation";
    JobTypes["TRANSLATION__INSTANT_MIGRATION"] = "translation:instant_migration";
    JobTypes["TRANSLATION__EXPORT_SERVICE"] = "translation:export_service";
    JobTypes["TRANSLATION__IMPORT_SERVICE"] = "translation:import_service";
    JobTypes["TRANSLATION__ASSET_IMPORT_SERVICE"] = "translation:asset_import_service";
    JobTypes["TRANSLATION__STUDY_IMPORT_SERVICE"] = "translation:study_import_service";
    JobTypes["TRANSLATION__STUDY_STATUS_SERVICE"] = "translation:study_status_service";
    JobTypes["IRB_V2__CREATE_PACKAGE_STEP_1"] = "irb_v2:create_package_step_1";
    JobTypes["IRB_V2__CREATE_PACKAGE_STEP_2_GENERATE_TEMPLATE_SCREENSHOTS"] = "irb_v2:create_package_step_2_generate_template_screenshots";
    JobTypes["IRB_V2__CREATE_PACKAGE_STEP_3_TRACK_REAL_SCREENSHOT_API"] = "irb_v2:create_package_step_3_track_real_screenshot_api";
    JobTypes["IRB_V2__CREATE_PACKAGE_STEP_4_COMPOSE_FINAL_PACKAGE"] = "irb_v2:create_package_step_4_compose_final_package";
    JobTypes["IRB_V2__CREATE_PACKAGE_STEP_5_TRACK_REPORT_PDF"] = "irb_v2:create_package_step_5_track_report_pdf";
    JobTypes["IRB_V2__CREATE_PACKAGE_TIMEOUT"] = "irb_v2:create_package_timeout";
    JobTypes["IRB__CREATE_PACKAGE_STEP_1_PROCESS_QUEUE"] = "irb:create_package_step_1_process_queue";
    JobTypes["IRB__CREATE_PACKAGE_STEP_2_GENERATE_TEMPLATE_SCREENSHOTS"] = "irb:create_package_step_2_generate_template_screenshots";
    JobTypes["IRB__CREATE_PACKAGE_STEP_3_TRACK_REAL_SCREENSHOT_API"] = "irb:create_package_step_3_track_real_screenshot_api";
    JobTypes["IRB__CREATE_PACKAGE_STEP_4_COMPOSE_FINAL_PACKAGE"] = "irb:create_package_step_4_compose_final_package";
    JobTypes["IRB__CREATE_PACKAGE_STEP_5_TRACK_REPORT_PDF"] = "irb:create_package_step_5_track_report_pdf";
})(JobTypes || (exports.JobTypes = JobTypes = {}));
exports.POLL_JOB_TYPES = new Set([
    JobTypes.IRB__CREATE_PACKAGE_STEP_3_TRACK_REAL_SCREENSHOT_API,
    JobTypes.IRB_V2__CREATE_PACKAGE_STEP_3_TRACK_REAL_SCREENSHOT_API,
    JobTypes.IRB__CREATE_PACKAGE_STEP_5_TRACK_REPORT_PDF,
    JobTypes.IRB_V2__CREATE_PACKAGE_STEP_5_TRACK_REPORT_PDF,
    JobTypes.IRB_V2__CREATE_PACKAGE_TIMEOUT,
]);
function isPollJobType(type) {
    return exports.POLL_JOB_TYPES.has(type);
}
var JobStatus;
(function (JobStatus) {
    JobStatus["NEW"] = "new";
    JobStatus["IN_PROGRESS"] = "in_progress";
    JobStatus["ERROR"] = "error";
    JobStatus["DONE"] = "done";
})(JobStatus || (exports.JobStatus = JobStatus = {}));
//# sourceMappingURL=types.js.map